var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',{attrs:{"value":_vm.answer,"max":_vm.params.max,"min":_vm.params.min,"readonly":"","thumb-label":"always"}})}
var staticRenderFns = []

export { render, staticRenderFns }